export default {
  common: {
    live: 'LIVE',
    saveClose: 'Save & Close',
    pressEnterToReturn: 'Press Enter or Backspace to return',
  },
  video: {
    pressFor: 'PRESS FOR {label}',
    unavailable: 'VIDEO UNAVAILABLE',
    networkError: 'NETWORK TEMPORARILY UNAVAILABLE',
    networkErrorDesc:
      'Thank you for your patience as we work to get everything up and running again.',
  },
  aw: {
    pressFor: 'Press for {label}',
  },
  menu: {
    settings: 'SETTINGS',
    manageLocations: 'Manage Locations',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',
    mapSettings: 'Map Settings',
    rotateLocations: 'Rotate Locations',
    hourly: 'Hourly',
    daily: 'Daily',
    maps: 'Maps',
    pressToExit: 'PRESS TO EXIT',
  },
  weather: {
    currentWeather: 'CURRENT WEATHER',
    hourly: 'HOURLY',
    currentConditions: 'CURRENT CONDITIONS',
    lookingAhead: 'Looking Ahead',
    minutecastError: 'MINUTECAST TEMPORARILY UNAVAILABLE',
    minutecastErrorDesc:
      'Thank you for your patience as we work to get everything up and running again',
    minutecastTitle: 'MINUTECAST™',
    today: 'Today',
    tonight: 'Tonight',
    night: 'Night',
    hi: 'Hi',
    lo: 'Lo',
    mapError: 'MAP TEMPORARILY UNAVAILABLE',
    mapErrorDesc: 'Thank you for your patience as we work to get everything up and running again.',
    conditions: {
      dew_point: 'DEW POINT',
      humidity: 'HUMIDITY',
      wind: 'WIND',
      gusts: 'GUSTS',
      pressure: 'PRESSURE',
      uv_index: 'UV INDEX',
      visibility: 'VISIBILITY',
    },
    units: {
      in: 'in',
    },
  },
  location: {
    notFound: 'Unable to find location',
  },
  home: {
    lifeSaving: 'LIFE SAVING',
    superiorAccuracy: 'SUPERIOR ACCURACY',
    protection: 'PROTECTION',
    searchPrompt: 'Search for your location',
  },
  search: {
    enterZipCode: 'Enter Zip Code',
    search: 'Search',
  },
  settings: {
    radar: 'Radar',
    satellite: 'Satellite',
    precipitation: 'Precipitation',
    rotation: 'Rotation',
    rotate: 'Rotate',
    duration: 'Duration',
    seconds: 'seconds',
    minutes: 'minutes',
  },
  loading: {
    title: 'Loading',
    subtitleMap: 'Thank you for your patience,\nnow launching map in full screen mode',
    subtitleDefault: 'Thank you for your patience,\nnow launching in full screen mode',
    unableToLoad: 'Unable to load',
    checkConnection: 'Please check your connection\nand try again',
    lastModified: 'LAST MODIFIED',
  },
  maps: {
    types: {
      radar: 'Radar',
      satellite: 'Satellite',
      standardSatellite: 'Standard Satellite',
      futureRadar: 'Future Radar',
      precipitation: 'Precipitation',
      watchesAndWarnings: 'Watches And Warnings',
      tropical: 'Tropical',
      temperatureContour: 'Temperature Contour',
      visibleSatellite: 'Visible Satellite',
      waterVapor: 'Water Vapor',
    },
    legend: {
      rain: 'Rain',
      thunderstorm: 'Thunderstorm',
      snow: 'Snow',
      ice: 'Ice',
      mix: 'Mix',
      low: 'Low',
      high: 'High',
    },
  },
  legal: {
    spanishUnavailable:
      'Esta página está disponible únicamente en inglés en este momento. Para la versión oficial, visite el sitio web de AccuWeather.',
    visitOfficialPage: 'Visit official page',
  },
}
